"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OnClickOutside = /** @class */ (function (_super) {
    __extends(OnClickOutside, _super);
    function OnClickOutside() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outsideClick = function () {
            _this.props.events.onClickOutside();
        };
        return _this;
    }
    OnClickOutside.prototype.componentDidMount = function () {
        document.addEventListener("click", this.outsideClick);
    };
    OnClickOutside.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.outsideClick);
    };
    OnClickOutside.prototype.render = function () {
        return this.props.children || null;
    };
    return OnClickOutside;
}(React.Component));
exports.default = OnClickOutside;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/behaviors/OnClickOutside/OnClickOutside.js
// module id = 1836
// module chunks = 8